export enum UserActionType {
  FETCH_ME_SUCCESS = 'USER.FETCH_ME',
  SAVE_SETTINGS_SUCCESS = 'USER.SAVE_SETTINGS_SUCCESS',
  USER_LOGIN_STARTED = 'USER_LOGIN_STARTED',
  LOGOUT_USER = 'LOGOUT_USER',
  USER_ACTION_ERROR = 'USER_ACTION_ERROR',
  RESET_STATE = 'RESET_STATE',
  REMOVE_TOUR_STEP = 'REMOVE_TOUR_STEP',
  REMOVE_ALL_TOUR_STEPS = 'REMOVE_ALL_TOUR_STEPS',
  REMOVE_MULTIPLE_TOUR_STEPS = 'REMOVE_MULTIPLE_TOUR_STEPS',
  UPDATE_SETTING = 'UPDATE_SETTING'
}

export type UserState = {
  me: {
    firstName: string;
    lastName: string;
    username: string;
    id: number;
  } | null;
  settings: {
    copyrightTerms: any;
    licensing: any;
    suppressedExpirationAlerts?: any;
    suppress2025Modal?: boolean;
    locale?: string;
    tours?: any;
  } | null;
  clickAways: any[];
  has2025Licenses: boolean;
  clickAwaysById: any;
  licenses: any[];
  licensesById: any;
  isLoggedOut: boolean;
  isAuthenticated: boolean;
  isForbidden: boolean;
  isAuditor: boolean;
  tours: any;

  managedUser: boolean;
  error: any;
};

export type UserAction =
  | { type: UserActionType.FETCH_ME_SUCCESS; data: any }
  | { type: UserActionType.SAVE_SETTINGS_SUCCESS; data: any }
  | { type: UserActionType.USER_LOGIN_STARTED }
  | { type: UserActionType.LOGOUT_USER }
  | { type: UserActionType.USER_ACTION_ERROR; data: any }
  | { type: UserActionType.REMOVE_TOUR_STEP; data: any }
  | { type: UserActionType.REMOVE_ALL_TOUR_STEPS; data: any }
  | {
      type: UserActionType.REMOVE_MULTIPLE_TOUR_STEPS;
      data: { tourName: string; stepNames: string[] };
    }
  | { type: UserActionType.UPDATE_SETTING; data: { name: string; value: any } }
  | { type: UserActionType.RESET_STATE };
